var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfCircleMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 232,
    viewBox: "0 0 269 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.455 11.7729C267.814 51.4932 274.139 105.928 254.182 150.948C184.149 101.719 87.365 103.773 19.0651 161.122C-10.3674 107.945 0.354277 39.6584 48.1754 -1.67658C103.049 -49.1073 186.004 -43.091 233.455 11.7729Z",
    fill: "#E94444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.185 150.948C246.582 168.107 235.16 183.903 220.016 196.991C165.138 244.425 82.1831 238.409 34.7317 183.545C28.6299 176.491 23.4087 168.967 19.0687 161.118C87.3684 103.773 184.149 101.719 254.185 150.948Z",
    fill: "#46B6E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircleMobile);
export default __webpack_public_path__ + "static/media/halfCircleMobile.8e4d596d59d2143f091a83b46218552f.svg";
export { ForwardRef as ReactComponent };